(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tusk-affiliate-how"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
    function init(flow) {
      if (flow.dataset.ahReady === '1') return;
      var tl = flow.querySelector('[data-ah-tl]');
      var steps = Array.prototype.slice.call(flow.querySelectorAll('[data-ah-step]'));
      if (!tl || !steps.length) return;
      flow.dataset.ahReady = '1';
      var head = flow.querySelector('.tusk-ah-head');
      var pinQ = window.matchMedia('(min-width: 901px) and (prefers-reduced-motion: no-preference)');
      var vertQ = window.matchMedia('(max-width: 900px)');
      var pinned = false;
      var marks = [];

      /* pin only when the heading and the whole timeline fit on one screen */
      function decidePin() {
        var need = (head ? head.offsetHeight + parseFloat(getComputedStyle(head).marginBottom) : 0) + tl.offsetHeight + 64;
        var want = pinQ.matches && need <= window.innerHeight;
        if (want !== pinned) { pinned = want; flow.classList.toggle('is-pinned', want); }
      }
      /* the track sits 12px under the image row */
      function placeTrack() {
        if (vertQ.matches) { tl.style.removeProperty('--track-y'); return; }
        var img = steps[0].querySelector('[data-ah-img]');
        if (img) tl.style.setProperty('--track-y', (img.offsetTop + img.offsetHeight + 12) + 'px');
      }
      /* each step lights when the line reaches the middle of its image,
         measured along the track (across on desktop, down on phones) */
      function measure() {
        var t = tl.getBoundingClientRect();
        marks = steps.map(function (s) {
          var r = s.querySelector('[data-ah-img]').getBoundingClientRect();
          return vertQ.matches
            ? (r.top + r.height / 2 - t.top) / t.height
            : (r.left + r.width / 2 - t.left) / t.width;
        });
      }
      /* scroll position -> 0..1, frame by frame, so the line moves exactly as
         fast as the page does */
      function progress() {
        var vh = window.innerHeight;
        if (pinned) {
          var r = flow.getBoundingClientRect();
          var run = r.height - vh;
          return run > 0 ? clamp(-r.top / run) : 1;
        }
        var t = tl.getBoundingClientRect();
        if (vertQ.matches) return clamp((vh * 0.6 - t.top) / t.height);
        return clamp((vh * 0.85 - t.top) / (vh * 0.6));
      }
      function render() {
        var p = progress();
        tl.style.setProperty('--fill', p.toFixed(4));
        for (var i = 0; i < steps.length; i++) steps[i].classList.toggle('is-on', p >= marks[i]);
      }
      var queued = false;
      function onScroll() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; render(); });
      }
      function relayout() { placeTrack(); decidePin(); measure(); onScroll(); }

      flow.setAttribute('data-ready', '');
      placeTrack();
      decidePin();
      measure();
      render();
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('resize', relayout, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(relayout).observe(tl);
      steps.forEach(function (s) { var im = s.querySelector('img'); if (im && !im.complete) im.addEventListener('load', relayout); });
    }
    function initAll(scope) { (scope || document).querySelectorAll('[data-ah-flow]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tusk-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tusk-home]').forEach((root) => {
    const visual = root.querySelector('[data-tusk-visual]');
    const glyph = root.querySelector('[data-tusk-glyph]');
    const steps = Array.from(root.querySelectorAll('[data-tusk-step]'));
    if (!visual || !glyph || steps.length === 0) return;
    const activate = (step) => {
      steps.forEach((item) => item.classList.toggle('is-active', item === step));
      visual.className = `tusk-category-visual state-${step.dataset.state}`;
      glyph.textContent = step.dataset.number;
    };
    activate(steps[0]);
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible) activate(visible.target);
    }, { rootMargin: '-32% 0px -32% 0px', threshold: [0.15, 0.5, 0.8] });
    steps.forEach((step) => observer.observe(step));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tusk-shell"] && !Shopify.designMode) return;
  try {
    
  /* Swap the sticky visual when a statement crosses the visual's own vertical
     middle — a fixed line, so the timing does not drift with statement height.
     The previous build ranked statements by IntersectionObserver ratio inside
     a -32%/-32% band, which fired early or late depending on how tall each
     block happened to be. */
  (function () {
    function init(root) {
      if (root.dataset.tuskStickyReady === '1') return;
      var visual = root.querySelector('[data-tusk-visual]');
      var glyph  = root.querySelector('[data-tusk-glyph]');
      var panes  = Array.prototype.slice.call(root.querySelectorAll('[data-tusk-pane]'));
      var steps  = Array.prototype.slice.call(root.querySelectorAll('[data-tusk-step]'));
      if (!visual || steps.length === 0) return;
      root.dataset.tuskStickyReady = '1';

      var current = -1;

      function activate(i) {
        if (i === current) return;
        current = i;
        var step = steps[i];
        steps.forEach(function (el, n) { el.classList.toggle('is-active', n === i); });
        visual.className = 'tusk-category-visual state-' + step.dataset.state;
        if (glyph) glyph.textContent = step.dataset.number;
        panes.forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.tuskPane === step.dataset.tuskStep);
        });
      }

      function pick() {
        var v = visual.getBoundingClientRect();
        /* under 900px the shared visual is display:none and every statement
           carries its own image, so there is nothing to drive -- bail out
           rather than compute against a zero-height box. */
        if (v.height === 0) return;
        var line = v.top + v.height / 2;
        var idx = 0;
        for (var n = 0; n < steps.length; n++) {
          if (steps[n].getBoundingClientRect().top <= line) idx = n;
        }
        activate(idx);
      }

      var queued = false;
      function onScroll() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; pick(); });
      }

      activate(0);
      pick();
      /* capture:true so this also catches scroll events from a theme wrapper
         that is itself the scrolling element, not just the window. */
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('resize', onScroll, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(onScroll).observe(root);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-tusk-sticky]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    /* re-init when the theme editor re-renders this section */
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
